// Runtime configuration for the SPA.
//
// In the container, /config.js is generated at startup from environment
// variables and sets window.APP_CONFIG, so a single image can be promoted
// across environments. In local dev (`npm run serve`) /config.js is empty and
// we fall back to the build-time values from .env (process.env.VUE_APP_*).
//
// Only static process.env.VUE_APP_* references are inlined by webpack, so the
// fallbacks below must be spelled out individually (dynamic lookups won't work).
const runtime =
  (typeof window !== "undefined" && window.APP_CONFIG) || {};

const buildTime = {
  VUE_APP_BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
  VUE_APP_COGNITO_USER_POOL_ID: process.env.VUE_APP_COGNITO_USER_POOL_ID,
  VUE_APP_COGNITO_USER_POOL_CLIENT_ID:
    process.env.VUE_APP_COGNITO_USER_POOL_CLIENT_ID,
  // Base URL of the public short-link/file host (the micro-site), e.g.
  // https://myurl.to or http://localhost:8787 in dev. Short links are built as
  // `${shortBaseUrl}/${slug}`. Falls back to window.location.origin if unset.
  VUE_APP_SHORT_BASE_URL: process.env.VUE_APP_SHORT_BASE_URL,
};

function value(key) {
  const v = runtime[key];
  // Ignore empty strings and unsubstituted "${VAR}" placeholders.
  if (v !== undefined && v !== null && v !== "" && !String(v).startsWith("${")) {
    return v;
  }
  return buildTime[key];
}

export const config = {
  backendBaseUrl: value("VUE_APP_BACKEND_BASE_URL"),
  cognitoUserPoolId: value("VUE_APP_COGNITO_USER_POOL_ID"),
  cognitoUserPoolClientId: value("VUE_APP_COGNITO_USER_POOL_CLIENT_ID"),
  shortBaseUrl: value("VUE_APP_SHORT_BASE_URL"),
};
